import React from 'react'
import { RADOM_COLORS } from '../util/Constants'

export function Trash(props: React.SVGProps<SVGSVGElement>): React.ReactElement {
  return <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke={RADOM_COLORS.ORANGE}
    xmlns="http://www.w3.org/2000/svg"
    style={{ width: 20 }}
    {...props}
  >
    <path
      d="M14 11V17"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 11V17"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6 7V19C6 20.1046 6.89543 21 8 21H16C17.1046 21 18 20.1046 18 19V7"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4 7H20"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7 7L9 3H15L17 7"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
}
